module.exports = __webpack_public_path__ + "img/no-image.42454b90.png";